import { useCompanies } from "contexts/CompaniesContext";
import { useIntegrationPageName } from "portal-ui-remote/IntegrationPageNameContext";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getTitleForRoute } from "utils/routeTitle";

const usePageTitles = () => {
  const loc = useLocation();
  const { activeCompany } = useCompanies();
  const { integrationPageName } = useIntegrationPageName();

  useEffect(() => {
    const path = loc.pathname;
    const integrationKey =
      path.includes("integrations") &&
      path.includes("manage") &&
      !path.includes("sources") &&
      path.split("/").pop();

    if (integrationKey) {
      const pathWithoutManageAndKey = path.slice(0, -11); // removes /manage/{platformKey} from path
      const generatedTitle = getTitleForRoute(pathWithoutManageAndKey);
      if (integrationPageName) {
        document.title = `${integrationPageName} ${generatedTitle}`;
        return;
      }
      return;
    }

    const threadId = path.includes("threads") && path.split("/").pop();
    if (threadId) {
      if (activeCompany) {
        const titleParts = getTitleForRoute(path).split("|");
        document.title = `${activeCompany.name} | ${titleParts
          .slice(-2)
          .join("|")}`;
        return;
      }
      document.title = "Spend Insights | Codat Portal";
      return;
    }

    // Swap company ID for name to give users human-friendly page titles
    if (path.includes("/companies/")) {
      if (activeCompany) {
        const titleParts = getTitleForRoute(path).split("|");
        titleParts[1] = ` ${activeCompany.name} `;

        document.title = titleParts.join("|");
        return;
      }
      const titleParts = getTitleForRoute(path).split("|");

      // If no company name is available, remove the company ID from the title
      document.title = titleParts.filter((_, i) => i !== 1).join("|");
      return;
    }

    document.title = getTitleForRoute(loc.pathname);
  }, [loc, activeCompany, integrationPageName]);
};

export default usePageTitles;
